const STEPS = [
  {
    num: "01",
    icon: "ri-route-line",
    title: "找到资源入口",
    desc: "在站内通过搜索、分区或标签找到想下的本子。先确认资源来源是否稳定、是否支持批量操作，再决定下载方式。",
    tip: "优先选择标注了“打包”“合集”“全量”标识的资源，省去二次合并。",
  },
  {
    num: "02",
    icon: "ri-list-check-3",
    title: "勾选与加入队列",
    desc: "单本可直接进入详情页；多本则在列表页勾选需要的内容，一键加入批量下载队列，避免一本一本重复操作。",
    tip: "批量前先清点清单，避免重复下载占用空间。",
  },
  {
    num: "03",
    icon: "ri-cloud-line",
    title: "选择下载与转存方式",
    desc: "网速稳定可直接保存到本地；需要长期留档或担心断线，就先转入离线空间，再按需转移到本设备。",
    tip: "大文件建议先离线转存，等完成后一次性本地拉取。",
  },
  {
    num: "04",
    icon: "ri-hard-drive-2-line",
    title: "整理压缩与归档",
    desc: "资源到达本地后，可统一解压、重命名、按作者或系列归类，必要时打成压缩包，方便日后查找与移动。",
    tip: "养成命名规范，例如“作者_系列_标题”，后期检索更省心。",
  },
];

export default function Tutorial() {
  return (
    <section id="tutorial" className="relative w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] gap-10 lg:gap-16 items-start">
          <div className="lg:sticky lg:top-24">
            <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-accent-600">
              <i className="ri-map-pin-user-line"></i>
              详细教程步骤
            </span>
            <h2 className="font-display text-2xl md:text-4xl text-foreground-950 mt-3 leading-snug">
              从资源下载到本地保存，
              <br className="hidden md:block" />
              四步轻松搞定
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              本子网站下载教程并不复杂，关键是把每一步做对。以下按实际操作顺序拆解，
              全程无需特殊技术背景，跟着序号走即可。
            </p>

            <a
              href="#tools"
              className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-secondary-500 text-background-50 text-sm font-semibold hover:bg-secondary-600 transition-colors whitespace-nowrap"
            >
              配套工具推荐
              <i className="ri-tools-fill"></i>
            </a>

            <div className="mt-8 rounded-2xl bg-accent-100/70 border border-accent-200 p-5">
              <p className="text-sm text-accent-900 leading-relaxed">
                <i className="ri-information-line mr-1"></i>
                小贴士：如果某个步骤卡住，先检查网络与存储空间是否充足。绝大多数下载失败都源于这两处，
                排查完往往立刻就能继续。
              </p>
            </div>
          </div>

          <div className="relative">
            <div className="absolute left-[26px] top-4 bottom-4 w-px bg-background-300 hidden sm:block"></div>
            <ol className="space-y-5">
              {STEPS.map((s) => (
                <li key={s.num} className="relative flex gap-4 sm:gap-5">
                  <span className="relative z-10 shrink-0 w-[52px] h-[52px] flex items-center justify-center rounded-2xl bg-primary-500 text-background-50 font-display text-lg shadow-soft">
                    {s.num}
                  </span>
                  <div className="flex-1 rounded-2xl bg-background-50 border border-background-200 p-5 md:p-6">
                    <div className="flex items-center gap-2.5">
                      <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                        <i className={`${s.icon}`}></i>
                      </span>
                      <h3 className="font-display text-lg md:text-xl text-foreground-950">{s.title}</h3>
                    </div>
                    <p className="mt-3 text-sm text-foreground-700 leading-relaxed">{s.desc}</p>
                    <p className="mt-3 inline-flex items-start gap-1.5 text-xs text-accent-700 bg-accent-100/60 rounded-lg px-3 py-2">
                      <i className="ri-lightbulb-flash-line mt-0.5"></i>
                      {s.tip}
                    </p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}